<template>
  <div class="row country-pill-row">
    <div class="col-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3 text-white text-center h3 mb-4">
      <a class="text-white" v-on:click="changeCountry" style="cursor: pointer;">
      <div class="country-pill">
        <img class="flag" :src="require(`@/assets/flags/flag-${country_flag_image}.svg`)">
        <div class="country-text"><p>{{ country_name }}</p></div>
        <img src="@/assets/arrows/chev-right.svg" style="float:right; padding-top: 32px; padding-right: 20px;">
      </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AbacoFlag',
  props: ['country_name', 'country_flag_image', 'country_short_code'],
  methods: {
    changeCountry () {
      this.$bvModal.hide('countrySelect')
      document.cookie = 'country=' + this.country_short_code + '; expires=86400000; path=/'
      this.$emit('onSelectCountry', this.country_short_code)
    }
  }
}
</script>

<style>
.country-text {
  height:100%;
  vertical-align: middle;
}
.country-text > p {
  position: absolute;
  top: 34%;
  font-size: 1.2rem;
}
.country-pill > div {
  margin: 0 auto;
  max-width: 100%;
  max-height: 100%;
  top: 27px;
  vertical-align: middle;
  color: #000000;
  float: left;
}
.country-pill-row {
  margin-left: 5px;
  margin-right: 5px;
}
.country-pill {
  position: relative;
  display: inline-block;
  background-color: #ffffff;
  width: 100%;
  height: 83px;
  vertical-align: middle;
  border-radius: 10px;
}

.country-pill > img {
  display: block;
}

.flag-pill {
  margin: 20px;
  vertical-align: middle;
  text-align: center;
  display: table-cell;
  float: left;
}
.flag {
  max-width: 100%;
  max-height: 100%;
  display: block;
  vertical-align: middle;
  float: left;
  margin: 20px;
}
.arrow {
  float: right;
  padding: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/AbacoFlag.vue